import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import Skeleton from '@material-ui/lab/Skeleton';
import FlightTakeoffOutlinedIcon from '@material-ui/icons/FlightTakeoffOutlined';
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined';
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined';
import DirectionsBusOutlinedIcon from '@material-ui/icons/DirectionsBusOutlined';
import BrandingWatermarkOutlinedIcon from '@material-ui/icons/BrandingWatermarkOutlined';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';

import RequestAccordion from './request-accordion';
import VisaRequestChips from '../common/visa/visa-request-chips';
import VisaRequestDetails from '../common/visa/visa-request-details';
import HotelRequestChips from '../common/hotel/hotel-request-chips';
import HotelRequestDetails from '../common/hotel/hotel-request-details';
import FlightRequestChips from '../common/flight/flight-request-chips';
import FlightRequestDetails from '../common/flight/flight-request-details';
import RegistrationRequestChips from '../common/registration/registration-request-chips';
import RegistrationRequestDetails from '../common/registration/registration-request-details';
import TransportationRequestChips from '../common/transportation/transportation-request-chips';
import TransportationRequestDetails from '../common/transportation/transportation-request-details';

import * as SupplierTypes from '../../../magic-strings/supplier-type';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

import TransportationRequestAccordion from './transportation-request-accordion';

const useStyles = makeStyles(() => ({
  content: {
    height: 48,
    marginBottom: `5px`
  }
}));
const RequestCard = ({ loading, reservationRequest }) => {
  const classes = useStyles();
  const [user] = useState(checkTokenExpirationMiddleware());
  return (
    <>
      <Grid item xs={12}>
        <Card style={{ borderRadius: `0px`, marginBottom: `25px` }}>
          <CardHeader
            avatar={
              loading ? (
                <Skeleton variant="circle" width={40} height={40} />
              ) : (
                <Avatar aria-label="reservation-request">
                  <AssignmentOutlinedIcon />
                </Avatar>
              )
            }
            title={
              loading ? (
                <Skeleton height={20} width="35%" />
              ) : (
                `${reservationRequest.category} Reservation Request No. ${reservationRequest.id}`
              )
            }
            subheader={
              loading ? (
                <Skeleton height={15} width="30%" />
              ) : (
                `${new Date(reservationRequest.createDate).toDateString()}`
              )
            }
          />
          <CardContent>
            {loading ? (
              <Skeleton variant="rect" className={classes.content} />
            ) : reservationRequest.reservationRequestFlightResources &&
              reservationRequest.reservationRequestFlightResources.length > 0 ? (
              <RequestAccordion
                label={'Flight'}
                Icon={<FlightTakeoffOutlinedIcon fontSize="small" />}
                Chips={
                  <FlightRequestChips
                    variant={'outlined'}
                    flightResources={reservationRequest.reservationRequestFlightResources}
                  />
                }
                Details={
                  <FlightRequestDetails
                    flightResources={reservationRequest.reservationRequestFlightResources}
                  />
                }
                Action={
                  <Link
                    to={`/request/${reservationRequest.reservationRequestFlightResources[0].reservationReqId}/flight`}
                  >
                    <Button size="small" color="primary" variant="contained">
                      Make An Offer
                    </Button>
                  </Link>
                }
              />
            ) : null}
            {loading ? (
              <Skeleton variant="rect" className={classes.content} />
            ) : reservationRequest.reservationRequestVisaResources &&
              reservationRequest.reservationRequestVisaResources.length > 0 ? (
              <RequestAccordion
                label={'Visa'}
                Icon={<BrandingWatermarkOutlinedIcon fontSize="small" />}
                Chips={
                  <VisaRequestChips
                    variant={'outlined'}
                    visaResources={reservationRequest.reservationRequestVisaResources}
                  />
                }
                Details={
                  <VisaRequestDetails
                    visaResources={reservationRequest.reservationRequestVisaResources}
                  />
                }
                Action={
                  <Link
                    to={`/request/${reservationRequest.reservationRequestVisaResources[0].reservationReqId}/visa`}
                  >
                    <Button size="small" color="secondary" variant="contained">
                      Make An Offer
                    </Button>
                  </Link>
                }
              />
            ) : null}
            {loading ? null : reservationRequest.reservationRequestHotelResources.length > 0 ? (
              <RequestAccordion
                label={'Hotel'}
                Icon={<HotelOutlinedIcon fontSize="small" />}
                Chips={
                  <HotelRequestChips
                    variant={'outlined'}
                    customClasses={'outline-info'}
                    hotelResources={reservationRequest.reservationRequestHotelResources}
                  />
                }
                Details={
                  <HotelRequestDetails
                    hotelResources={reservationRequest.reservationRequestHotelResources}
                  />
                }
                Action={
                  <Link
                    to={`/request/${reservationRequest.reservationRequestHotelResources[0].reservationReqId}/hotel`}
                  >
                    <Button
                      size="small"
                      color="primary"
                      className="contain-info"
                      variant="contained"
                    >
                      Make An Offer
                    </Button>
                  </Link>
                }
              />
            ) : null}
            {loading ? null : reservationRequest.reservationRequestTransportationResources &&
              reservationRequest.reservationRequestTransportationResources.length > 0 ? (
              <TransportationRequestAccordion
                label={'Transportation'}
                Icon={<DirectionsBusOutlinedIcon fontSize="small" />}
                Chips={
                  <TransportationRequestChips
                    variant={'outlined'}
                    customClasses={'outline-warning'}
                    transportationResources={
                      reservationRequest.reservationRequestTransportationResources
                    }
                  />
                }
                Details={
                  <TransportationRequestDetails
                    transportationResources={
                      reservationRequest.reservationRequestTransportationResources
                    }
                  />
                }
                reservationReqId={reservationRequest.id}

                // Action={
                //   <Link
                //     to={`/request/${reservationRequest.reservationRequestTransportationResources[0].reservationReqId}/transportation`}
                //   >
                //     <Button
                //       size="small"
                //       color="secondary"
                //       className="contain-warning"
                //       variant="contained"
                //     >
                //       Make An Offer
                //     </Button>
                //   </Link>
                // }
              />
            ) : null}
            {loading ? null : reservationRequest.reservationRequestRegistrationResources &&
              reservationRequest.reservationRequestRegistrationResources.length > 0 ? (
              <RequestAccordion
                label={'Registration'}
                Icon={<HowToRegOutlinedIcon fontSize="small" />}
                Chips={
                  <RegistrationRequestChips
                    variant={'outlined'}
                    customClasses={'outline-success'}
                    registrationResources={
                      reservationRequest.reservationRequestRegistrationResources
                    }
                  />
                }
                Details={
                  <RegistrationRequestDetails
                    registrationResources={
                      reservationRequest.reservationRequestRegistrationResources
                    }
                  />
                }
                Action={
                  <Link
                    to={`/request/${reservationRequest.reservationRequestRegistrationResources[0].reservationReqId}/registration`}
                  >
                    <Button
                      size="small"
                      color="secondary"
                      className="contain-success"
                      variant="contained"
                    >
                      Make An Offer
                    </Button>
                  </Link>
                }
              />
            ) : null}

            <CardActions disableSpacing>
              {loading ? (
                <Skeleton height={20} width="50%" />
              ) : reservationRequest ? (
                <Grid container>
                  {reservationRequest.isStandalone === true &&
                  user.SupplierType === SupplierTypes.TourismCompany ? (
                    <Grid item xs={12}>
                      <Link
                        to={`/request/${reservationRequest.id}/standalone`}
                        style={{ float: `right` }}
                      >
                        <Button size="small" color="primary" variant="outlined">
                          Make A Standalone Offer
                        </Button>
                      </Link>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary" component="div">
                      Assigned: <b>{reservationRequest.assignedDate.substring(0, 10)}</b>
                    </Typography>
                  </Grid>
                </Grid>
              ) : null}
            </CardActions>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default RequestCard;
